// Sort all installed wallets by rdns, displayed in the WalletModal
export const EIP6963_WALLETS = [
  {
    uuid: '527bc850-2353-4296-af54-3a93d6e729a2',
    name: 'MetaMask',
    rdns: 'io.metamask',
  },
  {
    uuid: '0b862b05-ac09-4e87-8181-62cd9f600c4e',
    name: 'Coinbase Wallet',
    rdns: 'com.coinbase.wallet',
  },
  {
    uuid: 'e757bdd5-1235-4980-9d64-2660fd73360b',
    name: 'Rabby Wallet',
    rdns: 'io.rabby',
  },
  {
    uuid: '67d611adbacd49329cbc1cafe517aa1c',
    name: 'Rainbow',
    rdns: 'me.rainbow',
  },
  {
    uuid: 'f6da1437-b365-4d03-911d-776a58386eee',
    name: 'OKX Wallet',
    rdns: 'com.okex.wallet',
  },
  {
    uuid: '17a75577-87d9-448b-b33e-5df37202eb20',
    name: 'Phantom',
    rdns: 'app.phantom',
  },
  {
    uuid: 'bfb0a463-f904-499c-b8b0-fc8df4e5b780',
    name: 'Trust Wallet',
    rdns: 'com.trustwallet.app',
  },
  {
    uuid: '369dc557-e117-445e-920e-c5e3df97905a',
    name: 'Bitget Wallet',
    rdns: 'com.bitget.web3',
  },
  {
    uuid: '6844a0e5-f160-4d32-b426-a1dc61e62c76',
    name: 'TokenPocket',
    rdns: 'pro.tokenpocket',
  },
  {
    uuid: 'bd2a0cc1-7040-44ac-b377-8e74da619898',
    name: 'Coin98 Wallet',
    rdns: 'coin98.com',
  },
  {
    uuid: 'dadcfb70-fa75-4949-ad95-e15aa92daaac',
    name: 'Bybit Wallet',
    rdns: 'com.bybit',
  },
]
export const METAMASK_HOMEPAGE = 'https://metamask.io/'
export const COINBASE_DOWNLOAD_PAGE = 'https://go.cb-w.com/mtUDhEZPy1'
export const OKX_DOWNLOAD_PAGE =
  'https://chromewebstore.google.com/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge'
export const BITGET_DOWNLOAD_PAGE =
  'https://chromewebstore.google.com/detail/bitget-wallet-formerly-bi/jiidiaalihmmhddjgbnbgdfflelocpak'
